import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {ErrorPageComponent} from "./error-page/error-page.component";
import {HomeComponent} from "./home/home.component";
import {CardDetailComponent} from "./card-detail/card-detail.component";
import {TermsConditionsComponent} from "./terms-conditions/terms-conditions.component";

const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'error', component: ErrorPageComponent},
    {path: 'card-detail/:loanPurpose/:cardName', component: CardDetailComponent},
    {path: 'disclosures/:loanPurpose/:cardName', component: TermsConditionsComponent},
    {path: ':merchantId', pathMatch: 'full', component: HomeComponent},
    {path: ':merchantId/:other', component: HomeComponent},

    {path: '**', component: ErrorPageComponent},


];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesRoutingModule {
}
